import React, {Component} from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import CloseBtn from '../../components/CloseBtn';
import InnerWrap from './WrapProject';
import BackSound from '../../components/BackSound';
import * as routes from '../../const/routes';
import * as videos from '../../const/videos';
import {withUiContext} from '../../UiContext';
import MenuBtn from '../../components/MenuBtn';
import NavContent from '../../components/NavContent';
import { substations } from '../../const/substations';
import { products } from '../../const/projects';
import MapSection from '../../components/MapSection';
import MapLocation from '../../components/MapSection/MapLocation';

class Project extends Component {
    state = {
        intro:       this.props.ui.intro,
        navContent:   false,
        substationId: 1,
        popup:        {
            type:   null,
            opened: false,
            data:   null,
        },
    }

    toggleNav = () => {
        this.setState((prevState) => ({navContent: !prevState.navContent}));
    }

    onEnded = () => {
        this.setState({intro: false})
    }

    popupCloseHandler = () => {
        this.props.ui.videoEl.play();
        this.setState({
            popup: {
                classSfx: null,
                opened:   false,
                data:     null,
            },
        });
    }

    popupOpenHandler = (data, classSfx) => {
        this.props.ui.videoEl.pause();
        this.setState({
            popup: {
                classSfx,
                opened: true,
                data,
            },
        });
    }

    render() {
        const { intro, navContent, substationId, popup } = this.state;
        const currentSubstations = substations.find((item) => item.id === substationId);

        return (
            <InnerWrap
                popup = { popup }
                popupCloseHandler = { this.popupCloseHandler }
                title = { !intro && currentSubstations.name }
                video = { videos.podst220_bg }
                intro = {{
                    status: this.state.intro,
                    video: videos.podst220_main,
                    onEnded: this.onEnded,
                }}
            >
                <div className = 'hud__container-content'>
                    {!intro && (
                        <MenuBtn
                            className = { `animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}` }
                            onClick = { this.toggleNav }
                            onMouseEnter = { this.props.ui.playOverSound }
                        />
                    )}

                    <TransitionGroup className = 'menu-outer'>
                        {navContent && (
                            <CSSTransition
                                classNames = 'menu-transition'
                                timeout = { 300 }
                            >
                                <NavContent onClose = { this.toggleNav } />
                            </CSSTransition>
                        )}
                    </TransitionGroup>

                    { !intro && currentSubstations && (
                        <MapSection>
                            { currentSubstations.products && currentSubstations.products.map((item, index) => {
                                const { id, coordinates } = item;
                                const cart = products.find((key) => key.id === id);

                                return (
                                    <MapLocation
                                        className = { 'hud-map__location-project' }
                                        key = { index }
                                        label = { cart.name }
                                        link = { '#' }
                                        style = {{left: coordinates.x, top: coordinates.y }}
                                        onClick = { (event) => {
                                            event.preventDefault();
                                            this.popupOpenHandler(cart, 'cart');
                                        } }
                                    />
                                );
                            })}
                        </MapSection>
                    )}
                </div>

                <div className = 'hud__container-controls'>
                    {!intro && (
                        <BackSound navContent = { navContent } />
                    )}

                    <CloseBtn link = { routes.PODST } introStatus />
                </div>
            </InnerWrap>
        );
    }
}

export default withUiContext(Project);
